import { NgModule } from "@angular/core";
import { Routes } from "@angular/router";
import { AuthGuardService } from "app/shared/auth-guard.service";
import { canDeactivateGuard } from "app/shared/can-deactivate-guard.service";
import { EntityManagerProviderGuard } from "app/shared/entity-manager-guard";
import { SharedModule } from "app/shared/shared.module";
import { HandheldLayoutComponent } from "./handheld-layout.component";
import { HandheldHomeComponent } from "./handheld-home.component";
import { HandheldBinsComponent } from "./handheld-bins.component";
import { HandheldBinProcessComponent } from "./handheld-bin-process.component";

export const routes: Routes = [
  {
    path: "handheld",
    component: HandheldLayoutComponent,
    canActivate: [AuthGuardService],
    children: [
      {
        path: "",
        redirectTo: "home",
        pathMatch: "full",
      },
      {
        path: "home",
        component: HandheldHomeComponent,
        canActivate: [AuthGuardService, EntityManagerProviderGuard],
      },
      {
        path: "process-bins",
        component: HandheldBinsComponent,
        canActivate: [AuthGuardService, EntityManagerProviderGuard],
      },
      {
        path: "process-bin/:addonBinId",
        component: HandheldBinProcessComponent,
        canActivate: [AuthGuardService, EntityManagerProviderGuard],
        // Waits for an in-flight scan save; ngOnDestroy detaches the entities that save is still writing.
        canDeactivate: [canDeactivateGuard],
      },
    ],
  },
];

@NgModule({
  declarations: [
    HandheldLayoutComponent,
    HandheldHomeComponent,
    HandheldBinsComponent,
    HandheldBinProcessComponent,
  ],
  imports: [SharedModule],
})
export class HandheldModule {}
